export default {"src":"/_next/static/media/device-tracking.b61a7520.svg","height":142,"width":141,"blurWidth":0,"blurHeight":0};